import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "svg-icon-textTypeShape",
  "use": "svg-icon-textTypeShape-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" id=\"svg-icon-textTypeShape\"><path d=\"M10 7h6V1h-6zM0 11h16V8.999H0zm0-4h8V5H0zm0-4h8V.999H0zm0 12h16v-2H0z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol